exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".loading-overlay[data-v-a62723a2]{position:absolute;top:0;left:0;right:0;bottom:0;background:hsla(0,0%,100%,.7);display:flex;align-items:center;justify-content:center;z-index:5;backdrop-filter:blur(2px)}.loading-blur[data-v-a62723a2]{filter:blur(1px);opacity:.6}.kpi-card[data-v-a62723a2]{background:#fff;border-radius:12px;border:none;transition:transform .3s ease}.kpi-card[data-v-a62723a2]:hover{transform:translateY(-5px)}.icon-box[data-v-a62723a2]{width:48px;height:48px;border-radius:10px;display:flex;align-items:center;justify-content:center}.v-align-middle[data-v-a62723a2]{vertical-align:middle}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a62723a2","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/dashboard/VehiclePerformanceDashboard/components/KpiCard.vue
// module id = 1771
// module chunks = 0